import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Regulamin() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="regulamin-page">
      <div className="bg-slate-900 py-8">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/">
            <Button variant="ghost" className="text-slate-400 hover:text-white mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />Strona główna
            </Button>
          </Link>
          <h1 className="font-heading font-bold text-2xl text-white">Regulamin serwisu internetowego</h1>
          <p className="text-slate-400 mt-1">Giełda Budowlana</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10 space-y-8 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§1. Informacje ogólne</h2>
            <p>Niniejszy Regulamin określa zasady korzystania z serwisu internetowego „Giełda Budowlana", dostępnego pod adresem giełdabudowlana.pl (dalej: „Serwis").</p>
            <p className="mt-2">Właścicielem i administratorem Serwisu jest:</p>
            <p className="mt-1"><strong>Piotr Kowalczyk P&P Profinish</strong>, prowadzący działalność gospodarczą</p>
            <ul className="list-none mt-1 space-y-0.5 text-sm text-slate-600">
              <li>adres: ul. Banderii 4/276, 01-164 Warszawa</li>
              <li>NIP: 7962883242, REGON: 527450940</li>
              <li>e-mail: p.p.profinish@gmail.com</li>
              <li>kraj prowadzenia działalności: Polska</li>
            </ul>
            <p className="mt-2">(dalej: „Usługodawca").</p>
            <p className="mt-2">Regulamin jest udostępniany nieodpłatnie i dostępny w Serwisie w sposób umożliwiający jego pozyskanie, odtwarzanie i utrwalanie.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§2. Charakter Serwisu</h2>
            <p>Serwis „Giełda Budowlana" jest platformą internetową umożliwiającą:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>publikowanie ogłoszeń przez osoby prywatne,</li>
              <li>prezentację profili firm budowlanych,</li>
              <li>nawiązywanie kontaktu pomiędzy użytkownikami Serwisu.</li>
            </ul>
            <p className="mt-2">Usługodawca nie świadczy usług budowlanych, remontowych ani wykonawczych.</p>
            <p className="mt-1">Usługodawca nie jest stroną umów zawieranych pomiędzy użytkownikami Serwisu i nie ponosi odpowiedzialności za ich wykonanie.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§3. Użytkownicy Serwisu</h2>
            <p>Z Serwisu mogą korzystać osoby fizyczne oraz przedsiębiorcy (firmy).</p>
            <p className="mt-2">Serwis rozróżnia:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>konto osoby prywatnej</strong> – umożliwiające m.in. publikowanie ogłoszeń,</li>
              <li><strong>konto firmowe</strong> – przeznaczone dla przedsiębiorców.</li>
            </ul>
            <p className="mt-2">Rejestracja konta w Serwisie jest bezpłatna.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§4. Rejestracja i konto użytkownika</h2>
            <p>Utworzenie konta w Serwisie wymaga:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>podania prawdziwych i aktualnych danych,</li>
              <li>zaakceptowania Regulaminu,</li>
              <li>zapoznania się z Polityką prywatności.</li>
            </ul>
            <p className="mt-2">Użytkownik ponosi odpowiedzialność za działania podejmowane z wykorzystaniem swojego konta.</p>
            <p className="mt-1">Zabronione jest udostępnianie konta osobom trzecim.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§5. Ogłoszenia i treści użytkowników</h2>
            <p>Osoby prywatne mogą publikować ogłoszenia w Serwisie nieodpłatnie.</p>
            <p className="mt-2">Użytkownik dodający treści oświadcza, że:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>posiada prawo do ich publikacji,</li>
              <li>treści są zgodne z obowiązującym prawem,</li>
              <li>treści nie naruszają praw osób trzecich.</li>
            </ul>
            <p className="mt-2">Zabronione jest publikowanie treści bezprawnych, wprowadzających w błąd lub naruszających dobre obyczaje.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§6. Moderacja i usuwanie treści</h2>
            <p>Usługodawca zastrzega sobie prawo do:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>moderowania treści,</li>
              <li>usuwania ogłoszeń lub kont naruszających Regulamin,</li>
              <li>czasowego lub trwałego zablokowania konta użytkownika.</li>
            </ul>
            <p className="mt-2">Działania te podejmowane są w celu zapewnienia prawidłowego funkcjonowania Serwisu.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§7. Odpowiedzialność</h2>
            <p>Usługodawca dokłada starań, aby Serwis działał prawidłowo, jednak nie gwarantuje jego nieprzerwanej dostępności.</p>
            <p className="mt-2">Usługodawca nie odpowiada za:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>jakość usług świadczonych przez firmy prezentowane w Serwisie,</li>
              <li>przebieg i skutki współpracy pomiędzy użytkownikami,</li>
              <li>prawdziwość treści zamieszczanych przez użytkowników.</li>
            </ul>
            <p className="mt-2">Korzystanie z Serwisu odbywa się na własną odpowiedzialność użytkownika.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§8. Reklamacje</h2>
            <p>Użytkownik ma prawo składać reklamacje dotyczące funkcjonowania Serwisu.</p>
            <p className="mt-1">Reklamacje należy zgłaszać drogą elektroniczną na adres: <a href="mailto:p.p.profinish@gmail.com" className="text-orange-600 hover:underline">p.p.profinish@gmail.com</a>.</p>
            <p className="mt-1">Reklamacje rozpatrywane są w terminie do 14 dni od dnia ich otrzymania.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§9. Dane osobowe</h2>
            <p>Zasady przetwarzania danych osobowych określa <Link to="/polityka-prywatnosci" className="text-orange-600 hover:underline">Polityka prywatności</Link>, dostępna w Serwisie.</p>
            <p className="mt-1">Dane przetwarzane są zgodnie z obowiązującymi przepisami prawa.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§10. Postanowienia końcowe</h2>
            <p>Usługodawca zastrzega sobie prawo do zmiany Regulaminu.</p>
            <p className="mt-1">O zmianach Regulaminu użytkownicy zostaną poinformowani w Serwisie.</p>
            <p className="mt-1">W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy prawa polskiego.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
